import { useGTMWidgets } from 'hooks/utilities/useGTMWidgets';
import { useTranslation } from 'react-i18next';
import React from 'react';
import styles from './GTMWidgets.module.scss';

const GTMWidgets = () => {
  const { t } = useTranslation('gtmWidgets');
  const { showAccessibility, showCookie } = useGTMWidgets();

  return (
    <div className={styles.widgetWrapper}>
      <span className={styles.widget} onClick={showCookie}>
        {t('cookies')}
      </span>
      <span className={styles.widget} onClick={showAccessibility}>
        {t('accessibility')}
      </span>
    </div>
  );
};

export default GTMWidgets;
